// // import React from "react";
// // import {
// //   MdOutlineEmail,
// //   MdOutlineLocalPhone,
// //   MdOutlineLocationOn,
// // } from "react-icons/md";
// // import { ADDRESS, HEAD_OFFICE } from "../constants";

// // const Contact = () => {
// //   return (
// //     <div style={{ minHeight: "100vh", background: "#FFFFFF" }}>
// //       {/* Header */}

// //       <header className="relative text-center text-white mb-10 py-28 px-4 overflow-hidden">
// //         <div className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/2172494039/photo/business-help-desk.webp?a=1&b=1&s=612x612&w=0&k=20&c=HFXKXdJ8vgfgpNcZXXC8bZ7svdZLE5qgSVTsNHDGcqw=')] bg-cover bg-center"></div>
// //         <div className="absolute  inset-0 bg-gradient-to-t from-black/60 via-black/60 to-black/60"></div>
// //         <div className="relative z-10 max-w-4xl mx-auto">
// //           <h1
// //             style={{
// //               fontSize: "2.7rem",
// //               fontWeight: 700,
// //               margin: 0,
// //               lineHeight: 1.2,
// //             }}
// //           >
// //             Connect with <span className="text-[#FFD700]">Kubermax</span>
// //           </h1>
// //           <p style={{ fontSize: "1.15rem", marginTop: 12, color: "#e0e0e0" }}>
// //             Whether you're looking for support or have general inquiries, our
// //             team is ready to help.
// //           </p>
// //         </div>
// //       </header>

// //       {/* Main Card */}
// //       <div
// //         style={{
// //           maxWidth: 1100,
// //           margin: "40px auto",
// //           background: "#fff",
// //           borderRadius: 18,
// //           boxShadow: "0 4px 24px 0 rgba(0,0,0,0.07)",
// //           padding: "40px 32px",
// //           display: "flex",
// //           flexDirection: "row",
// //           gap: 40,
// //           flexWrap: "wrap",
// //           border: "1px solid #E5E5E5",
// //         }}
// //       >
// //         {/* Left Column */}
// //         <div style={{ flex: 1, minWidth: 280, paddingRight: 16 }}>
// //           <h2
// //             style={{
// //               fontSize: "1.5rem",
// //               fontWeight: 700,
// //               color: "#1D3557",
// //               marginBottom: 18,
// //             }}
// //           >
// //             Contact Information
// //           </h2>
// //           <ul
// //             style={{ color: "#444", padding: 0, margin: 0, listStyle: "none" }}
// //           >

// //             <li style={{ marginBottom: 18 }}>
// //               <span style={{ fontWeight: 600, color: "#1D3557" }}>
// //                 Branch Address:
// //               </span>
// //               <br />
// //               Circular Road, Bhatti gate, Jhajjar, Haryana- 124103
// //             </li>
// //             <li style={{ marginBottom: 18 }}>
// //               <span style={{ fontWeight: 600, color: "#1D3557" }}>Email:</span>
// //               <br />
// //               <a
// //                 href="mailto:support@kubermax.in"
// //                 style={{ color: "#4FA0FF", textDecoration: "none" }}
// //               >
// //                 support@kubermax.in
// //               </a>
// //               <br />
// //               <a
// //                 href="mailto:kubermax@gmail.com"
// //                 style={{ color: "#4FA0FF", textDecoration: "none" }}
// //               >
// //                 kubermax@gmail.com
// //               </a>
// //             </li>
// //             <li style={{ marginBottom: 18 }}>
// //               <span style={{ fontWeight: 600, color: "#1D3557" }}>Phone:</span>
// //               <br />
// //               <a
// //                 href="tel:+919896769742"
// //                 style={{ color: "#4FA0FF", textDecoration: "none" }}
// //               >
// //                 +91-9896769742
// //               </a>
// //             </li>
// //             <li>
// //               <span style={{ fontWeight: 600, color: "#1D3557" }}>Hours:</span>
// //               <br />
// //               Monday to Saturday, 9:00 AM – 6:00 PM
// //             </li>
// //           </ul>
// //         </div>

// //         {/* Right Column - Contact Form */}
// //         <div style={{ flex: 1, minWidth: 280 }}>
// //           <form style={{ display: "flex", flexDirection: "column", gap: 20 }}>
// //             <div>
// //               <label
// //                 style={{
// //                   display: "block",
// //                   fontWeight: 600,
// //                   color: "#1D3557",
// //                   marginBottom: 6,
// //                 }}
// //               >
// //                 Your Name
// //               </label>
// //               <input
// //                 type="text"
// //                 name="name"
// //                 style={{
// //                   width: "100%",
// //                   border: "1px solid #E5E5E5",
// //                   borderRadius: 8,
// //                   padding: "12px 16px",
// //                   fontSize: "1rem",
// //                   outline: "none",
// //                   marginBottom: 0,
// //                 }}
// //                 placeholder="Enter your full name"
// //                 required
// //               />
// //             </div>
// //             <div>
// //               <label
// //                 style={{
// //                   display: "block",
// //                   fontWeight: 600,
// //                   color: "#1D3557",
// //                   marginBottom: 6,
// //                 }}
// //               >
// //                 Your Email
// //               </label>
// //               <input
// //                 type="email"
// //                 name="email"
// //                 style={{
// //                   width: "100%",
// //                   border: "1px solid #E5E5E5",
// //                   borderRadius: 8,
// //                   padding: "12px 16px",
// //                   fontSize: "1rem",
// //                   outline: "none",
// //                   marginBottom: 0,
// //                 }}
// //                 placeholder="example@domain.com"
// //                 required
// //               />
// //             </div>
// //             <div>
// //               <label
// //                 style={{
// //                   display: "block",
// //                   fontWeight: 600,
// //                   color: "#1D3557",
// //                   marginBottom: 6,
// //                 }}
// //               >
// //                 Your Message
// //               </label>
// //               <textarea
// //                 name="message"
// //                 rows={4}
// //                 style={{
// //                   width: "100%",
// //                   border: "1px solid #E5E5E5",
// //                   borderRadius: 8,
// //                   padding: "12px 16px",
// //                   fontSize: "1rem",
// //                   outline: "none",
// //                   marginBottom: 0,
// //                   resize: "vertical",
// //                 }}
// //                 placeholder="How can we help you?"
// //                 required
// //               ></textarea>
// //             </div>
// //             <button
// //               type="submit"
// //               style={{
// //                 width: "100%",
// //                 background: "#FFD700",
// //                 color: "#1D3557",
// //                 fontWeight: 600,
// //                 padding: "12px 0",
// //                 borderRadius: 8,
// //                 border: "none",
// //                 fontSize: "1rem",
// //                 marginTop: 8,
// //                 cursor: "pointer",
// //                 transition: "background 0.2s",
// //               }}
// //               onMouseOver={(e) =>
// //                 (e.currentTarget.style.background = "#FFE55C")
// //               }
// //               onMouseOut={(e) => (e.currentTarget.style.background = "#FFD700")}
// //             >
// //               Send Message
// //             </button>
// //           </form>
// //         </div>
// //       </div>

// //       <div className="max-w-[1300px] mx-auto py-20 px-5">
// //         <div className="mb-20">
// //           <h2 className="font-bold text-4xl md:text-5xl text-[#1D3557] text-center mb-10">
// //             For Business Contact
// //           </h2>
// //           {/* Table */}
// //           <div className="overflow-x-auto">
// //             <table className="w-full border border-[#E5E5E5] rounded-2xl shadow-lg overflow-hidden">
// //               <thead>
// //                 <tr className="bg-[#4FA0FF] text-white">
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[35%]">
// //                     Email
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[30%]">
// //                     Phone No.
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[35%]">
// //                     Address
// //                   </th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-[#E5E5E5]">
// //                 <tr className="hover:bg-gray-100 transition">
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     <span className="text-[#1D3557] font-medium">Email:- </span>{" "}
// //                     info@kubermax.in
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     <span className="text-[#1D3557] font-medium">Phone No:- </span>
// //                     +91-9896769742
// //                   </td>

// //                   <td className="py-5 px-6 text-gray-700 leading-relaxed text-md md:text-lg">
// //                     <p>
// //                      Circular Road, Bhatti gate, Jhajjar, Haryana- 124103
// //                     </p>
// //                   </td>
// //                 </tr>
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>

// //         <div className="mb-20">
// //           <h2 className="font-bold text-4xl md:text-5xl text-[#1D3557] text-center mb-6">
// //             For Grievance Contact -{" "}
// //             <span className="text-[#FFD700]">Kubermax</span>
// //           </h2>
// //           <p className="text-gray-600 max-w-2xl mx-auto text-center mb-10 text-lg md:text-xl">
// //             We're here to help you. Reach out to us through any of the following
// //             channels and our team will assist you promptly.
// //           </p>

// //           {/* Table */}
// //           <div className="overflow-x-auto">
// //             <table className="w-full border border-[#E5E5E5] rounded-2xl shadow-lg overflow-hidden">
// //               <thead>
// //                 <tr className="bg-[#4FA0FF] text-white">
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[20%]">
// //                     Name
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md-text-lg w-[20%]">
// //                     Email
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md-text-lg w-[20%]">
// //                     Phone No.
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md-text-lg w-[40%]">
// //                     Address
// //                   </th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-[#E5E5E5]">
// //                 <tr className="hover:bg-gray-100 transition">
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     <h3 className="text-[#1D3557] font-medium">Mr. Ajay</h3>
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     grievances@kubermax.in
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     +91 9254069150
// //                   </td>

// //                   <td className="py-5 px-6 text-gray-700 leading-relaxed text-md md-text-lg">
// //                     <p>{ADDRESS}</p>
// //                   </td>
// //                 </tr>

// //                 <tr className="hover:bg-gray-100 transition">
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     <h3 className="text-[#1D3557] font-medium">Mr. Manjeet Singh</h3>
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     grievance.nodal@kubermax.in
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     +91 9896769742
// //                   </td>

// //                   <td className="py-5 px-6 text-gray-700 leading-relaxed text-md md-text-lg">
// //                     <p>{ADDRESS}</p>
// //                   </td>
// //                 </tr>
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>

// //         {/* Kubermarg foundation Limited Section */}
// //         <div>
// //           <h2 className="font-bold text-4xl md:text-5xl text-[#1D3557] text-center mb-6">
// //             For Grievance Contact -
// //             <span className="text-[#FFD700]">Kubermarg foundation</span>
// //           </h2>
// //           <p className="text-gray-600 max-w-2xl mx-auto text-center mb-10 text-lg md:text-xl">
// //             We're here to help you. Reach out to us through any of the following
// //             channels and our team will assist you promptly.
// //           </p>

// //           {/* Table */}
// //           <div className="overflow-x-auto">
// //             <table className="w-full border border-[#E5E5E5] rounded-2xl shadow-lg overflow-hidden">
// //               <thead>
// //                 <tr className="bg-[#4FA0FF] text-white">
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[20%]">
// //                     Name
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[20%]">
// //                     Email
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[20%]">
// //                     Phone No.
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[40%]">
// //                     Address
// //                   </th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-[#E5E5E5]">
// //                 <tr className="hover:bg-gray-100 transition">
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     <h3 className="text-[#1D3557] font-medium">
// //                       Mr. Ajay
// //                     </h3>
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     mr.ajay@kubermarg.com
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     +91 9254069150
// //                   </td>

// //                   <td className="py-5 px-6 text-gray-700 leading-relaxed text-md md:text-lg">
// //                     <p>
// //                       Address:Circular Road, Bhatti gate, Jhajjar, Haryana- 124103
// //                     </p>
// //                   </td>
// //                 </tr>

// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Map Section */}
// //       <section
// //         style={{
// //           maxWidth: 1100,
// //           margin: "48px auto",
// //           padding: "0 16px",
// //         }}
// //       >
// //         <h2
// //           style={{
// //             fontSize: "1.25rem",
// //             fontWeight: 700,
// //             color: "#1D3557",
// //             marginBottom: 16,
// //           }}
// //         >
// //           Visit Our Office
// //         </h2>
// //         <div
// //           style={{
// //             width: "100%",
// //             height: 350,
// //             borderRadius: 12,
// //             overflow: "hidden",
// //             boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
// //             border: "1px solid #E5E5E5",
// //           }}
// //         >
// //           <iframe
// //             title="Kubermax Office Location"
// //             style={{ width: "100%", height: "100%", border: 0 }}
// //             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27683.812318625836!2d76.65369031548517!3d28.60532021887385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d7065cf3e455b%3A0xa2b76c96db235a23!2sBhatti%20Gate%2C%20Jhajjar%2C%20Haryana%20124103!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
// //             allowFullScreen=""
// //             loading="lazy"
// //             referrerPolicy="no-referrer-when-downgrade"
// //           ></iframe>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default Contact;

// import React from "react";
// import {
//   MdOutlineEmail,
//   MdOutlineLocalPhone,
//   MdOutlineLocationOn,
// } from "react-icons/md";
// import { ADDRESS, HEAD_OFFICE } from "../constants";

// const Contact = () => {
//   return (
//     <div style={{ minHeight: "100vh", background: "#0B0F1A", color: "#E0E0E0" }}>
//       {/* Header */}
//       <header className="relative text-center mb-10 py-28 px-4 overflow-hidden">
//         <div className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/2172494039/photo/business-help-desk.webp?a=1&b=1&s=612x612&w=0&k=20&c=HFXKXdJ8vgfgpNcZXXC8bZ7svdZLE5qgSVTsNHDGcqw=')] bg-cover bg-center opacity-60"></div>
//         <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F1A]/80 via-[#0B0F1A]/70 to-[#0B0F1A]/60"></div>
//         <div className="relative z-10 max-w-4xl mx-auto">
//           <h1 className="text-4xl md:text-5xl font-bold text-[#FFD700] mb-4">
//             Connect with Kubermax
//           </h1>
//           <p className="text-lg md:text-xl text-gray-300">
//             Whether you're looking for support or have general inquiries, our team is ready to help.
//           </p>
//         </div>
//       </header>

//       {/* Main Card */}
//       <div
//         className="max-w-5xl mx-auto p-10 rounded-2xl shadow-xl flex flex-wrap gap-8"
//         style={{ background: "#1A2035", border: "1px solid #2E3350" }}
//       >
//         {/* Left Column */}
//         <div className="flex-1 min-w-[280px]">
//           <h2 className="text-2xl font-bold text-[#FFD700] mb-6">Contact Information</h2>
//           <ul className="space-y-5 text-gray-300">
//             <li>
//               <MdOutlineLocationOn className="inline-block mr-2 text-[#4FA0FF]" />
//               <span className="font-semibold text-[#FFD700]">Branch Address:</span> Circular Road, Bhatti Gate, Jhajjar, Haryana- 124103
//             </li>
//             <li>
//               <MdOutlineEmail className="inline-block mr-2 text-[#4FA0FF]" />
//               <span className="font-semibold text-[#FFD700]">Email:</span> <a href="mailto:support@kubermax.in" className="text-[#4FA0FF] hover:underline">support@kubermax.in</a>, <a href="mailto:kubermax@gmail.com" className="text-[#4FA0FF] hover:underline">kubermax@gmail.com</a>
//             </li>
//             <li>
//               <MdOutlineLocalPhone className="inline-block mr-2 text-[#4FA0FF]" />
//               <span className="font-semibold text-[#FFD700]">Phone:</span> <a href="tel:+919896769742" className="text-[#4FA0FF] hover:underline">+91-9896769742</a>
//             </li>
//             <li>
//               <span className="font-semibold text-[#FFD700]">Hours:</span> Monday to Saturday, 9:00 AM – 6:00 PM
//             </li>
//           </ul>
//         </div>

//         {/* Right Column - Contact Form */}
//         <div className="flex-1 min-w-[280px]">
//           <form className="flex flex-col gap-5">
//             <input type="text" name="name" placeholder="Your Name" className="p-3 rounded-lg bg-[#2E3350] border border-[#4FA0FF] text-gray-200 focus:outline-none" required />
//             <input type="email" name="email" placeholder="Your Email" className="p-3 rounded-lg bg-[#2E3350] border border-[#4FA0FF] text-gray-200 focus:outline-none" required />
//             <textarea name="message" rows="4" placeholder="Your Message" className="p-3 rounded-lg bg-[#2E3350] border border-[#4FA0FF] text-gray-200 focus:outline-none resize-y" required />
//             <button
//               type="submit"
//               className="bg-[#FFD700] text-[#0B0F1A] font-bold py-3 rounded-lg hover:bg-[#FFE55C] transition"
//             >
//               Send Message
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Tables Section */}
//       <div className="max-w-6xl mx-auto py-16 px-4 space-y-16">
//         {/* Business Contact */}
//         <div>
//           <h2 className="text-3xl md:text-4xl font-bold text-center text-[#FFD700] mb-8">
//             For Business Contact
//           </h2>
//           <div className="overflow-x-auto">
//             <table className="w-full text-left border-collapse">
//               <thead>
//                 <tr className="bg-[#4FA0FF] text-white">
//                   <th className="py-4 px-6 rounded-tl-lg">Email</th>
//                   <th className="py-4 px-6">Phone No.</th>
//                   <th className="py-4 px-6 rounded-tr-lg">Address</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-600">
//                 <tr className="hover:bg-[#2E3350] transition">
//                   <td className="py-4 px-6">info@kubermax.in</td>
//                   <td className="py-4 px-6">+91-9896769742</td>
//                   <td className="py-4 px-6">Circular Road, Bhatti Gate, Jhajjar, Haryana- 124103</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Grievance Contact */}
//         <div>
//           <h2 className="text-3xl md:text-4xl font-bold text-center text-[#FFD700] mb-6">
//             For Grievance Contact - Kubermax
//           </h2>
//           <p className="text-center text-gray-300 mb-6">
//             We're here to help you. Reach out to us through any of the following channels and our team will assist you promptly.
//           </p>
//           <div className="overflow-x-auto">
//             <table className="w-full text-left border-collapse">
//               <thead>
//                 <tr className="bg-[#4FA0FF] text-white">
//                   <th className="py-4 px-6">Name</th>
//                   <th className="py-4 px-6">Email</th>
//                   <th className="py-4 px-6">Phone No.</th>
//                   <th className="py-4 px-6">Address</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-600">
//                 <tr className="hover:bg-[#2E3350] transition">
//                   <td className="py-4 px-6">Mr. Ajay</td>
//                   <td className="py-4 px-6">grievances@kubermax.in</td>
//                   <td className="py-4 px-6">+91 9254069150</td>
//                   <td className="py-4 px-6">{ADDRESS}</td>
//                 </tr>
//                 <tr className="hover:bg-[#2E3350] transition">
//                   <td className="py-4 px-6">Mr. Manjeet Singh</td>
//                   <td className="py-4 px-6">grievance.nodal@kubermax.in</td>
//                   <td className="py-4 px-6">+91 9896769742</td>
//                   <td className="py-4 px-6">{ADDRESS}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Map Section */}
//         <section className="max-w-6xl mx-auto mt-10">
//           <h2 className="text-xl font-bold text-[#FFD700] mb-4">Visit Our Office</h2>
//           <div className="w-full h-80 rounded-xl overflow-hidden shadow-lg border border-[#2E3350]">
//             <iframe
//               title="Kubermax Office Location"
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27683.812318625836!2d76.65369031548517!3d28.60532021887385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d7065cf3e455b%3A0xa2b76c96db235a23!2sBhatti%20Gate%2C%20Jhajjar%2C%20Haryana%20124103!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
//               className="w-full h-full border-0"
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//             ></iframe>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default Contact;

import React from "react";
import { motion } from "framer-motion";
import {
  BRANCH_ADDRESS,
  EMAIL,
  INFO_EMAIL,
  PHONE,
  SUPPORT_PHONE,
  LSP_GRO_NAME,
  LSP_GRO_EMAIL,
  LSP_GRO_PHONE,
  LSP_NODAL_NAME,
  LSP_NODAL_EMAIL,
  LSP_NODAL_PHONE,
  NBFC_NAME,
  NBFC_ADDRESS,
  NBFC_PHONE,
  NBFC_GRO_NAME,
  NBFC_GRO_EMAIL,
  NBFC_NODAL_NAME,
  NBFC_NODAL_EMAIL,
} from "../constants";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const Contact = () => {
  return (
    <div
      className="min-h-screen  bg-gradient-to-b from-[#121A2F] via-[#0B1527] to-[#081021]
 text-white"
    >
      {/* Header with Animated Carousel */}
      <section className="relative overflow-hidden h-[450px]">
        {/* Working Slider */}
        <Slider
          dots={true}
          infinite={true}
          speed={1000}
          slidesToShow={1}
          slidesToScroll={1}
          autoplay={true}
          autoplaySpeed={5000}
          fade={true}
          arrows={false}
          className="h-[450px] w-full"
        >
          {/* Slide 1 */}
          <div>
            <div
              className="w-full h-[450px] bg-cover bg-center"
              style={{ backgroundImage: "url('/images/ctabanner.jpg')" }}
            >
              <div className="w-full h-full bg-black/50"></div>
            </div>
          </div>

          {/* Slide 2 */}
          <div>
            <div
              className="w-full h-[450px] bg-cover bg-center"
              style={{ backgroundImage: "url('/images/customer-service.jpg')" }}
            >
              <div className="w-full h-full bg-black/50"></div>
            </div>
          </div>

          {/* Slide 3 */}
          <div>
            <div
              className="w-full h-[450px] bg-cover bg-center"
              style={{ backgroundImage: "url('/images/customer-service-2.jpg')" }}
            >
              <div className="w-full h-full bg-black/50"></div>
            </div>
          </div>
        </Slider>

        {/* Content on top */}
        <motion.div
          className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="text-5xl md:text-6xl font-extrabold mb-4 text-[white]">
            Connect with <span className="text-[#4FA0FF]">Kubermax</span>
          </h1>

          <motion.p
            className="text-lg md:text-xl text-white/80 max-w-2xl"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            Whether you're looking for support or have general inquiries, our
            team is ready to help.
          </motion.p>
        </motion.div>
      </section>

      {/* Main Contact Section */}
      <section className="max-w-6xl mx-auto px-4 py-20 flex flex-col md:flex-row gap-10">
        {/* Contact Info */}
        <motion.div
          className="flex-1 border border-[#4FA0FF]/30 rounded-2xl p-8 shadow-lg bg-transparent"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold mb-6 text-[white]">
            Contact <span className="text-[#4FA0FF]">Information</span>
          </h2>
          <ul className="space-y-5 text-white/80">
            <li>
              <span className="font-semibold text-white">Branch Address:</span>
              <br />
              {BRANCH_ADDRESS}
            </li>
            <li>
              <span className="font-semibold text-white">Email:</span>
              <br />
              <a
                href={`mailto:${EMAIL}`}
                className="text-[#4FA0FF] hover:underline"
              >
                {EMAIL}
              </a>
              <br />
              {/* <a
                href="mailto:kubermax@gmail.com"
                className="text-[#4FA0FF] hover:underline"
              >
                kubermax@gmail.com
              </a> */}
            </li>
            <li>
              <span className="font-semibold text-white">Phone:</span>
              <br />
              <a
                href={`tel:${PHONE}`}
                className="text-[#4FA0FF] hover:underline"
              >
                {PHONE}
              </a>
            </li>
            <li>
              <span className="font-semibold text-white">Hours:</span>
              <br />
              Monday to Saturday, 9:00 AM – 6:00 PM
            </li>
          </ul>
        </motion.div>

        {/* Contact Form */}
        <motion.div
          className="flex-1 border border-[#4FA0FF]/30 rounded-2xl p-8 shadow-lg bg-transparent"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold mb-6 text-[white]">
            Send Us <span className="text-[#4FA0FF]">a Message</span>{" "}
          </h2>
          <form className="flex flex-col gap-4">
            <input
              type="text"
              placeholder="Your Name"
              className="bg-transparent border border-[#4FA0FF]/50 rounded-md p-3 text-white placeholder-white/60 focus:outline-none focus:border-[#4FA0FF]"
              required
            />
            <input
              type="email"
              placeholder="Your Email"
              className="bg-transparent border border-[#4FA0FF]/50 rounded-md p-3 text-white placeholder-white/60 focus:outline-none focus:border-[#4FA0FF]"
              required
            />
            <textarea
              rows={4}
              placeholder="Your Message"
              className="bg-transparent border border-[#4FA0FF]/50 rounded-md p-3 text-white placeholder-white/60 focus:outline-none focus:border-[#4FA0FF]"
              required
            ></textarea>
            <motion.button
              type="submit"
              className="bg-[#4FA0FF] hover:bg-[#3a8ed9] transition-colors rounded-md p-3 font-semibold mt-2"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Send Message
            </motion.button>
          </form>
        </motion.div>
      </section>

      {/* Business Contacts Table */}
      <section className="max-w-6xl mx-auto px-4 py-10">
        <motion.h2
          className="text-3xl font-bold mb-6 text-[white] text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          For Business <span className="text-[#4FA0FF]">Contact</span>
        </motion.h2>
        <div className="overflow-x-auto">
          <table className="w-full border border-[#4FA0FF]/30 rounded-2xl shadow-lg overflow-hidden text-white bg-transparent">
            <thead>
              <tr className="bg-[#4FA0FF]/80 text-white">
                <th className="py-4 px-6 font-semibold">Email</th>
                <th className="py-4 px-6 font-semibold">Phone No.</th>
                <th className="py-4 px-6 font-semibold">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#4FA0FF]/30">
              <tr className="hover:bg-[#4FA0FF]/10 transition">
                <td className="py-4 px-6">{INFO_EMAIL}</td>
                <td className="py-4 px-6">{PHONE}</td>
                <td className="py-4 px-6">{BRANCH_ADDRESS}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      
      {/* Customer Support Table */}
      <section className="max-w-6xl mx-auto px-4 py-10">
        <motion.h2
          className="text-3xl font-bold mb-6 text-[white] text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          For Customer Support <span className="text-[#4FA0FF]">Contact</span>
        </motion.h2>
        <div className="overflow-x-auto">
          <table className="w-full border border-[#4FA0FF]/30 rounded-2xl shadow-lg overflow-hidden text-white bg-transparent">
            <thead>
              <tr className="bg-[#4FA0FF]/80 text-white">
                <th className="py-4 px-6 font-semibold">Email</th>
                <th className="py-4 px-6 font-semibold">Phone No.</th>
                <th className="py-4 px-6 font-semibold">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#4FA0FF]/30">
              <tr className="hover:bg-[#4FA0FF]/10 transition">
                <td className="py-4 px-6">{EMAIL}</td>
                <td className="py-4 px-6">{SUPPORT_PHONE}</td>
                <td className="py-4 px-6">{BRANCH_ADDRESS}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Grievance Contact */}
      <section className="max-w-6xl mx-auto px-4 py-10">
        <motion.h2
          className="text-3xl font-bold mb-6 text-[white] text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          For Grievance{" "}
          <span className="text-[#4FA0FF]">Contact - Kubermax (LSP)</span>
        </motion.h2>
        <div className="overflow-x-auto">
          <table className="w-full border border-[#4FA0FF]/30 rounded-2xl shadow-lg overflow-hidden text-white bg-transparent">
            <thead>
              <tr className="bg-[#4FA0FF]/80 text-white">
                <th className="py-4 px-6 font-semibold">Name</th>
                <th className="py-4 px-6 font-semibold">Email</th>
                <th className="py-4 px-6 font-semibold">Phone No.</th>
                <th className="py-4 px-6 font-semibold">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#4FA0FF]/30">
              <tr className="hover:bg-[#4FA0FF]/10 transition">
                <td className="py-4 px-6">{LSP_GRO_NAME}</td>
                <td className="py-4 px-6">{LSP_GRO_EMAIL}</td>
                <td className="py-4 px-6">{LSP_GRO_PHONE}</td>
                <td className="py-4 px-6">{BRANCH_ADDRESS}</td>
              </tr>
              <tr className="hover:bg-[#4FA0FF]/10 transition">
                <td className="py-4 px-6">{LSP_NODAL_NAME}</td>
                <td className="py-4 px-6">{LSP_NODAL_EMAIL}</td>
                <td className="py-4 px-6">{LSP_NODAL_PHONE}</td>
                <td className="py-4 px-6">{BRANCH_ADDRESS}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* NBFC Grievance Contact */}
      <section className="max-w-6xl mx-auto px-4 py-10">
        <motion.h2
          className="text-3xl font-bold mb-6 text-[white] text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          For Grievance{" "}
          <span className="text-[#4FA0FF]">
            Contact - {NBFC_NAME} (NBFC)
          </span>
        </motion.h2>
        <div className="overflow-x-auto">
          <table className="w-full border border-[#4FA0FF]/30 rounded-2xl shadow-lg overflow-hidden text-white bg-transparent">
            <thead>
              <tr className="bg-[#4FA0FF]/80 text-white">
                <th className="py-4 px-6 font-semibold">Role</th>
                <th className="py-4 px-6 font-semibold">Name</th>
                <th className="py-4 px-6 font-semibold">Email</th>
                <th className="py-4 px-6 font-semibold">Phone No.</th>
                <th className="py-4 px-6 font-semibold">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#4FA0FF]/30">
              <tr className="hover:bg-[#4FA0FF]/10 transition">
                <td className="py-4 px-6">Grievance Redressal Officer</td>
                <td className="py-4 px-6">{NBFC_GRO_NAME}</td>
                <td className="py-4 px-6">{NBFC_GRO_EMAIL}</td>
                <td className="py-4 px-6">{NBFC_PHONE}</td>
                <td className="py-4 px-6">{NBFC_ADDRESS}</td>
              </tr>
              <tr className="hover:bg-[#4FA0FF]/10 transition">
                <td className="py-4 px-6">Nodal Officer</td>
                <td className="py-4 px-6">{NBFC_NODAL_NAME}</td>
                <td className="py-4 px-6">{NBFC_NODAL_EMAIL}</td>
                <td className="py-4 px-6">{NBFC_PHONE}</td>
                <td className="py-4 px-6">{NBFC_ADDRESS}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Google Map */}
      <section className="max-w-6xl mx-auto px-4 py-10">
        <motion.h2
          className="text-3xl font-bold mb-6 text-[white]"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Visit <span className="text-[#4FA0FF]"> Our Office</span>
        </motion.h2>
        <motion.div
          className="w-full h-[400px] rounded-2xl overflow-hidden border border-[#4FA0FF]/30 shadow-lg bg-transparent"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <iframe
            title="Kubermax Office Location"
            className="w-full h-full border-0"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27683.812318625836!2d76.65369031548517!3d28.60532021887385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d7065cf3e455b%3A0xa2b76c96db235a23!2sBhatti%20Gate%2C%20Jhajjar%2C%20Haryana%20124103!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </motion.div>
      </section>
    </div>
  );
};

export default Contact;